module.exports = function (el) {
  var $el = $(el)

  var $a = $el.find('a')

  $a.on('click', function (e) {
    e.preventDefault()

    if ($(this).attr('target') === '_blank') {
      var w = 500

      var h = 300

      var left = ($(window).width() / 2) - (w / 2)

      var top = ($(window).height() / 2) - (h / 2)

      window.open(this.href, 'socialWindow', 'width=' + w + ',height=' + h + ',top=' + top + ',left= ' + left)
    }

    if ($(this).hasClass('anchor-comments')) {
      window.location = this.href
    }
  })
}
